<template>
  <!-- 用电综览 -->
  <div class="waterOverview">
    <selected @childEvent="childEvent"></selected>
         <div class="con">
              <div class="top-imgs">
                  <div class="combined imgs">
                      <div class="left-img">
                          <img src="@/assets/Overview/icon-20.png" />
                          <p> 综合能耗(tce)</p>
                      </div>
                      <div class="right-num">{{energyConsumptionVo.total}}</div>
                      <div class="right-img">
                           <img  src="@/assets/Overview/icon-20n.png" />
                      </div>
                  </div>
                  <div class="capita imgs">
                       <div class="left-img">
                          <img src="@/assets/Overview/icon-21.png" />
                          <p> 人均能耗(tce)</p>
                      </div>
                      <div class="right-num">{{energyConsumptionVo.peopleAvg}}</div>
                      <div class="right-img">
                           <img  src="@/assets/Overview/icon-21n.png" />
                      </div>
                  </div>
                  <div class="area imgs">
                       <div class="left-img">
                          <img src="@/assets/electric/icon-34.png" />
                          <p> 面积能耗(tce/m²)</p>
                      </div>
                      <div class="right-num">{{energyConsumptionVo.acreageAvg}}</div>
                      <div class="right-img">
                           <img  src="@/assets/electric/icon-34n.png" />
                      </div>
                  </div>
                  <div class="obversion imgs">
                      <div class="left-img">
                          <img src="@/assets/electric/icon-35.png" />
                          <p> 折算碳排量(co²)</p>
                      </div>
                      <div class="right-num">{{energyConsumptionVo.co2Convert}}</div>
                      <div class="right-img">
                           <img  src="@/assets/electric/icon-35n.png" />
                      </div>
                  </div>
              </div>
                <div class="information-analysis" :style="{'height':`${heights - 669}px`}">
                  <div class="information" >
                      <div class="mytitle">{{BuildingInfo.name || '-'}}</div>
                      <div class="information-item" :style="{'height':`${heights - 719}px`}">
                           <div class="info-item">
                              <div class="info-num">{{BuildingInfo.inlineQuantity || '-'}}</div>
                              <div class="info-txt">进线数量(条)</div>
                           </div>
                            <div class="info-item">
                              <div class="info-num">{{BuildingInfo.transformerQuantity || '-'}}</div>
                              <div class="info-txt">变压器数量(个)</div>
                           </div>
                            <div class="info-item">
                              <div class="info-num">{{BuildingInfo.monitorPoints || '-'}}</div>
                              <div class="info-txt">监测点数(个)</div>
                           </div>
                            <div class="info-item">
                              <div class="info-num">{{BuildingInfo.burdenCapacity || '-'}}</div>
                              <div class="info-txt">负荷容量(VA)</div>
                           </div>
                            <div class="info-item">
                              <div class="info-num">{{BuildingInfo.totalCapacityKVA || '-'}}</div>
                              <div class="info-txt">总容量(KVA)</div>
                           </div>
                           <div class="info-item mymore" @click="dialogVisible=true">
                                 <span>更多</span>
                           </div>
                      </div>
                  </div>
                  <div class="analysis">
                         <div class="mytitle">
                            <span>能源分析</span>
                             <div class="em">
                                最大值 <span class="num">{{maxnum}}t</span>
                                <div class="time">{{dated}}</div>
                              </div>
                         </div>
                          <div class="mycahrt" :style="{'height':`${heights - 710}px`}">
                            <div id="chart_example" style="width:100%;height:100%;"></div>
                          </div>
                  </div>
              </div>
               <div class="itemize-region" :style="{'height':`${heights - 505}px`}">
                   <div class="itemize">
                         <div class="mytitle">分项用水占比</div>
                            <div id="proportion" style="width:100%;height:50%;"></div>
                             <el-scrollbar style="height:41%;width: 100%;">
                            <div class="boxed">
                                <div v-if="EnergySubItemTotals.length"> 
                                    <div class="progress"  v-for="(item,index) in EnergySubItemTotals"
                                      :key="index">
                                      <div class="tit">
                                            <p>
                                              {{item.Name}}<span>{{item.Value / total * 100 | shuzi
                                              }}%</span>
                                            </p>
                                              <span>
                                                {{item.Value}} t
                                              </span>
                                          </div>
                                      <!-- <div class="jindu"><span :style="item.Value | widthed(total)">{{item.Value / total * 100 | shuzi
                                          }}%</span></div> -->
                                        <el-progress :text-inside="false" :stroke-width="10" :percentage="item.Value / total * 100 | shuzi"></el-progress>
                                    </div>
                                </div>
                              </div>
                                </el-scrollbar>
                   </div>
                   <div class="region">
                     <div class="mytitle">区域用水排行</div>
                       <div :style="{'height':`${heights - 730}px`}">
                          <div id="Ranking" style="width:100%;height:100%;"></div>
                       </div>
                       <div class="mytable">
                            <el-table :data="tableData" border style="width: 100%;" stripe :height="heights - 789">
                              <template slot="empty">
                                <span class="noData">
                                  <img src="@/assets/noData.png" alt="暂无数据">
                                  <span class="text">暂无数据</span>
                                </span>
                              </template>
                               <el-table-column type="index" label="序号" width="90" align="center"></el-table-column>
                              <el-table-column align="center" prop="Name" label="名称"></el-table-column>
                              <el-table-column align="center" prop="Value" label="用水量(t)">
                              </el-table-column>

                            </el-table>
                       </div>
                   </div>
              </div>
          </div>
          <el-dialog title="更多信息" v-dialogDrag :visible.sync="dialogVisible" width="400" center>
        <el-form :inline="true" ref="temp" label-width="143px" class="demo-temp">
          <el-form-item v-for="(item,index) in BuildingInfocolumns" :key='index' :label="item.name" :prop="item.key">
            <!-- <span v-if="item.key=='buildingAppearancePhoto'" style="display: flex;align-items: center;" class="beijing">
            <el-image v-if="item.key=='buildingAppearancePhoto'" style="width: 100px; height: 100px"
            :src="BuildingInfo[item.key]" :preview-src-list="[BuildingInfo.buildingAppearancePhoto]">
          </el-image>
          </span> -->
            <span v-if="item.key=='buildingAppearancePhoto'"
              style="display: flex;flex-direction: column;position: relative;" class="beijing">
              <input style="opacity: 0;margin-bottom: 54px;"></input>
              <el-image v-if="item.key=='buildingAppearancePhoto'"
                style="width: 100px;margin-right: 15px;position: absolute;" :src="BuildingInfo[item.key]"
                :preview-src-list="[BuildingInfo.buildingAppearancePhoto]">

              </el-image>
            </span>

            <span v-else-if="item.key=='energyBuildingTypeId'">
              <el-select v-model="optionsed[BuildingInfo.energyBuildingTypeId]" clearable placeholder="请选择" disabled
                style="width: 176px;">
                <el-option v-for="(item,i) in optionsed" :key="i" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </span>

            <span v-else-if="item.key == 'coordinate'">
              <input v-model="BuildingInfo.coordinate" readonly>
            </span>
            <!-- <span v-else style="width:200px;display: inline-block;">{{BuildingInfo[item.key] }}</span> -->
            <input v-else v-model="BuildingInfo[item.key]" :placeholder="'请输入'+item.name" disabled>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">确 定
            </el-button>
          </span>
        </template>
         </el-dialog>
          <div class="el-loading-mask" v-show="isMask">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>
    <!-- 遮罩层 -->
    <!-- <div class="mask" v-if="isMask">
      <i class="el-icon-loading" style="color:#409eff;font-size:60px"></i>
    </div> -->
  </div>
</template>

<script>

  //   import { EnergyUsePowerAnalyseDay, EnergyUsePowerAnalyseMonth, EnergyUsePowerAnalyseYear } from "@/utils/request";
  import * as echarts from 'echarts';
  //   import { parseTime } from "@/utils";
  import {getElectricity} from "../../../api/overView";
  import {findAllBuildingType} from "../../../api/buildingApi";
  import selected from '../../../components/module/temp/select_left.vue';
  import $ from 'jquery';
  var proportion,middle2,myChart;

  export default {
    components: {
      selected
    },
    //利用计算属性
    computed: {
      
      nowBuilding () {//当前建筑
        return this.$store.cacheStore.state.setBuilding;
      }
    },

    //监听执行
    watch: {
      listData (val) {
        this.valueId=val;
        this.childEvent(this.valueIndex);
      },
      nowBuilding (val) {
        //  this.temp_fn(this.timerType)
        this.areaObj=val
        this.childEvent(this.valueIndex,val);
      },
    },
    filters: {
      widthed: (v,total) => {
        var d=v/total*100;
        if(d) {
          return 'width:'+d+'%'
        } else {
          return 'width:0'
        }

      },
      shuzi: function(v) {
        if(v) {
          return v.toFixed('2')
        }
        return 0
      },
      guolv: function(v) {
        if(v) {
          return v.toFixed(4)
        } else {
          return '-'
        }
      }
    },
    data () {
      return {
        BuildingInfocolumns: [{
          name: "名称",
          key: "name",
          width: 170
        },{
          name: "编号",
          key: "code"
        }
          ,{
          name: "区域外观图",
          key: "buildingAppearancePhoto",
          width: 120
        }
          ,{
          name: "区域类型",
          key: "energyBuildingTypeId",
          width: 120,
        }
          ,{
          name: "进线来源",
          key: "inlineSource"
        }
          ,{
          name: "进线数量(个)",
          key: "inlineQuantity"
        }
          ,{
          name: "区域面积(m³)",
          key: "buildingArea"
        }
          ,{
          name: "变压器数量(个)",
          key: "transformerQuantity",
          width: 120
        }
          ,{
          name: "总容量(KVA)",
          key: "totalCapacityKVA",
          width: 120
        }
          ,{
          name: "监测点数(个)",
          key: "monitorPoints"
        }
          ,{
          name: "电房数量(个)",
          key: "electricRoomQuantity"
        }
          ,{
          name: "负荷容量(KVA)",
          key: "burdenCapacity"
        }

          ,{
          name: "年度计划用电(kwh)",
          key: "annualPlanUsePower",
          width: 165
        },{
          name: "坐标",
          key: "coordinate",
          width: 165
        },
        {
          name: "年度计划用水(t)",
          key: "annualPlanUseWater"
        },{
          name: "年度计划用气(m³)",
          key: "annualPlanUseGas"
        },{
          name: "区域面积指标(m³)",
          key: "buildingAreaIndicator"
        },{
          name: "区域人数(人)",
          key: "buildingPopulation"
        },{
          name: "区域人数指标(人)",
          key: "buildingPopulationIndicator"
        },{
          name: "备注",
          key: "memo"
        }
        ],
        isMask: false,//遮罩层
        areaObj: {},
        // dated: parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}'),
        // dated: (new Date()).toLocaleString(),
        dated: (new Date()).toLocaleString(),
        valueIndex: 0,
        total: 0,//分项用电占比总数
        dialogVisible: false,
        BuildingInfo: {Id: "5b25c177120d11ecb23800163e125285",Code: "一号建筑",Name: "一号建筑"},
        EnergySubItemTotals: [],//分项用电占比
        OrganizationEnergyTotals: [{OrganizationName: "其他组织 ",EnergyTotals: []}],
        ThisIssueData: [],
        Total: {TotalEnergyConsumption: 0,BuildingAreaEnergyConsumption: 0,BuildingPopulationEnergyConsumption: 0},
        valueId: '',
        options: {
          tooltip: {
            trigger: "item"
          },
          legend: {
            type: 'scroll',
            data: ["无数据"],
            bottom: "15%",
            left: 'center',
            icon: "circle", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            // itemWidth: 10, // 设置宽度
            // itemHeight: 10, // 设置高度
            // itemGap: 20 // 设置间距
          },
          label: {
            alignTo: "edge",
            formatter: "{name|{b}}\n{time|{c}}",
            minMargin: 5,
            edgeDistance: 10,
            lineHeight: 15,
            rich: {
              time: {
                fontSize: 10,
                color: "#999"
              }
            }
          },

          color: ["#60acf2","#4ecb73","#6071f2","#36cbcb"],
          series: [
            {
              name: "分项用电占比分析",
              type: "pie",
              radius: "59%",
              center: ["50%","40%"],
              itemStyle: {
                borderColor: "#fff",
                borderWidth: 1
              },
              labelLine: {
                normal: {
                  length: 0
                }
              },
              data: [
                {value: 0,name: "无数据"},
                {value: 0,name: "无数据"},
                {value: 0,name: "无数据"},
                {value: 0,name: "无数据"}
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          ]
        },
        options2: {
          grid: {
            top: "8% ",
            left: 100,
            right: 25,
            bottom: 46
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "line" // 'shadow' as default; can also be 'line' or 'shadow'
            }
          },
          legend: {
            data: ["综合","电"],
            top: 50,
            right: 10,
            orient: "vertical",
            icon: "rect", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 10, // 设置宽度
            itemHeight: 10, // 设置高度
            itemGap: 25 // 设置间距
          },

          xAxis: {
            type: "category",
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false,
              textStyle: {
                color: '#000',
                fontSize: '16'
              }
            },
            axisLine: {
              show: false
            },
            data: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
            splitLine: {
              //网格线
              show: true
            }
          },
          yAxis: {
            type: "value"
          },
          color: ["#60acf2","#6071f2"],
          series: [
            {
              name: "总能耗",
              data: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
              type: "bar",
              barGap: 0,
              emphasis: {
                focus: "series"
              },
            },

          ]
        },

        tableData: [

        ],
        columns: [
          {
            name: "部门",
            key: "name",
          },

          {
            name: "其他组织",
            key: "address",
          },
        ],
        maxnum: '',
        dayData: [],
        monthData: [],
        yearData: [],
        iconStatused: false,
         middleData: {
          legend: {
            data: [],
            bottom: 0,

            icon: "rect", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 10, // 设置宽度
            itemHeight: 10, // 设置高度
            itemGap: 25 // 设置间距
          },
          grid: {
            top: "8% ",
            left: 72,
            right: 20,
            bottom: 46
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow" // 'shadow' as default; can also be 'line' or 'shadow'
            }
          },
          xAxis: {
            splitLine: {
              //网格线
              show: true
            },
            splitArea: {
              //坐标轴在 grid 区域中的分隔区域，默认不显示。
              interval: "auto",
              show: false, //是否显示分隔区域
              areaStyle: {
                color: ["rgba(250,250,250,0.3)","rgba(200,200,200,0.3)"], //分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
                shadowColor: "red", //阴影颜色
                shadowOffsetX: 0, //阴影水平方向上的偏移距离。
                shadowOffsetY: 0, //阴影垂直方向上的偏移距离
                shadowBlur: 10, //图形阴影的模糊大小。
                opacity: 1 //图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形
              }
            },
            type: "category",
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false,
              textStyle: {
                color: '#000',
                fontSize: '16'
              }
            },
            axisLine: {
              show: false
            },
            z: 99,
            data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月',]
          },
          yAxis: {
            type: "value"
          },
          color: ['#36cbcb'],
          series: [
            {
              data: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
              type: "line",
              showBackground: true,
              backgroundStyle: {
                color: "rgba(180, 180, 180, 0.2)"
              }
            }
          ]
        },
        energyConsumptionVo: {},//头部四个
        optionsed: {},
        dataType: "号",
        heights: document.getElementById('app').clientHeight,
      };
    },


    mounted () {
      //获取区域类型
      findAllBuildingType().then(res => {
        if(res.success) {
          res.data.forEach(item => {
            this.optionsed[item.id]=item.name
          })
        }
      })

      for(let i=1;i<=31;i++) {
        if(i<=24) {
          this.dayData.push(i)
        }
        if(i<=12) {
          this.yearData.push(i+'月')
        }
        this.monthData.push(i);
      }

      this.middleData.xAxis.data=this.dayData;
      // console.log("当前选中的区域",this.$store.cacheStore.state.setBuilding);
      this.areaObj=this.$store.cacheStore.state.setBuilding
      this.init();
      this.childEvent(this.valueIndex);
    },
    methods: {
      childEvent (v) {
        this.valueIndex=v;
        if(v===0) {
          this.middleData.xAxis.data=this.dayData;
          this.dataType='号'
          this.getList_fn(this.areaObj,'DAY');
        }
        if(v===1) {
          this.middleData.xAxis.data=this.monthData;
          this.dataType='月'
          // this.getListMonth();
          this.getList_fn(this.areaObj,'MONTH');
        }
        if(v===2) {
          this.middleData.xAxis.data=this.yearData;
          this.dataType='年'
          // this.getListYear();
          this.getList_fn(this.areaObj,'YEAR');
        }
        $('.r .Ranking').height($('.proportion').height()+'px')
      },
      init () {
        // 能源分析图
        myChart=echarts.init(document.getElementById("chart_example"));
        // console.log("饼图",this.middleData);

        myChart.setOption(this.middleData);


        //部门用电排行
        middle2=echarts.init(document.getElementById("Ranking"));
        middle2.setOption(this.options2,true);
  
        //分项用电占比
        proportion=echarts.init(document.getElementById("proportion"));
        proportion.setOption(this.options,true);
   
        
      },
      //获取数据
      getList_fn (item,type) {
        this.EnergySubItemTotals=[]
        var d={
          'areaId': item.id,
          'timeType': type,
          'energyType': 237,
        }
        this.isMask=true
        // console.log("参数",d);
        getElectricity(d).then(res => {
          //  console.log("数据",res);
          if(res.code==200) {
            this.BuildingInfo=res.data.areaByAreaIdVo
            this.energyConsumptionVo=res.data.energyConsumptionVo
            this.ThisIssueData_fn(res.data.thisIssueValues)
            // res.data.squipmentRatio

            var squipmentRatioArr=[] //分项
            for(var key in res.data.squipmentRatio[0]) {
              squipmentRatioArr.push({
                "Name": key,
                "Value": res.data.squipmentRatio[0][key]
              })
            }
            var subEnergyConsumption=[] //部门用电
            for(var key in res.data.subEnergyConsumption[0]) {
              subEnergyConsumption.push({
                "Name": key,
                "Value": res.data.subEnergyConsumption[0][key]
              })
            }
            this.tableData=subEnergyConsumption
            this.OrganizationEnergyTotals_fn(subEnergyConsumption)

            this.EnergySubItemTotals=squipmentRatioArr;//饼图
            if(this.EnergySubItemTotals.length) {
              this.total=0;
              this.options.legend.data=[];
              this.options.series[0].data=[];
              this.EnergySubItemTotals.map(v => {
                if(v.Value) {
                  v.Value=v.Value.toFixed(2);
                  this.total+=parseInt(v.Value);
                }

                this.options.legend.data.push(v.Name);
                this.options.series[0].data.push({
                  value: v.Value,
                  name: v.Name,
                });
              });
              this.total=this.total? this.total:0;
            }
            proportion.setOption(this.options,true);
            this.isMask=false;


          } else {
            this.isMask=false;
            this.$message({type: 'error',message: `获取失败,${res.message}`});
          }

        })
      },

      //新部门用电排行fn
      OrganizationEnergyTotals_fn (val) {
        // 部门用电排行
        this.options2.legend.data=[];
        this.options2.series=[];
        this.options2.xAxis.data=[];
        this.options2.series.push({
          // name: '',
          data: [],
          type: "bar",
          barGap: 0,
          barWidth: 30,//柱图宽度
          emphasis: {
            focus: "series"
          },
        });
        val.map((v,i) => {
          this.options2.xAxis.data.push(v.Name);
          this.options2.legend.data.push(v.Name);
          // this.options2.series[0].name=v.Name;
          this.options2.series[0].data.push(parseInt(v.Value*100)/100);
        });
        middle2.setOption(this.options2,true);

      },

      // 能源分析
      ThisIssueData_fn (val) {
        if(!val.length) {
          return
        }
        var ii=1;
        var b=[];
        // 能源分析   
        this.middleData.series=[];
        this.middleData.legend.data=[];
        var max=[]
        var date=""
        if(this.dataType=="号") {
          date=new Date().getDate()
        } else if(this.dataType=="月") {
          date=(new Date().getMonth())+1
        } else {
          date=new Date().getFullYear()
        }
        var valArr=[val[0].Values]
        valArr.map((e,i) => {
          this.middleData.legend.data.push('能源分析 '+date+this.dataType);
          this.middleData.series.push({
            name: '能源分析 '+date+this.dataType,
            data: [],
            type: "line",
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)"
            }
          })
          for(const key in e) {
            if(Object.hasOwnProperty.call(e,key)) {
              const element=e[key];
              if(key.indexOf("Value")==0) {
                this.middleData.series[i].data.push(element? element.toFixed(2):element);
                max.push(element);
                b.push(ii++);
              }
            }
          }
        })

        this.middleData.legend.data.length>6? this.middleData.legend.type='scroll':this.middleData.legend.type='plain';
        this.maxnum=Math.max(...max).toFixed(2);
        myChart.setOption(this.middleData,true);
      },



      tableRowClassName ({row,rowIndex}) {
        if(rowIndex%2===0) {
          return "success-row";
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .waterOverview {
   position: relative;
   overflow: hidden;
   .con {
     width: 100%;
     height: 100%;
     box-sizing: border-box;
    //  background-color: #fff;
      // padding: 12px 20px 20px 20px;
      .top-imgs {
        display: flex;
        height: 80px;
        .imgs {
            height: 100%;
            margin-right: 8px;
            padding: 8px 0px;
             box-sizing: border-box;
             border-radius: 2px;
             display: flex;
             align-items: center;
             position: relative;
            .left-img {
              min-width: 140px;
              height: 100%;
              text-align: center;
              // border-right: 1px solid #e6e6e6;
              
              p{
                font-size: 16px;
                color: #fff;
              }
            }
            .right-num {
              font-size: 24px;
              color: #fff;
              margin-left: 5px;
              font-weight: bold;
            }
            .right-img {
              position: absolute;
              bottom: -2px;
              right: 0px;
            }

        }
        .combined {
          width: 5.4rem;
          background-color: #8c79ac;
        }
        .capita {
          width: 4rem;
          background-color: #e35c59;
        }
        .area {
          width: 3.6rem;
          background-color: #43b7ae;
        }
        .obversion {
          width: 3.8rem;
          // width: calc(100% - 13.3rem);
          margin-right: 0px;
          background-color: #f59447;
        }

      }
      .information-analysis {
        width: 100%;
        height: 300px;
        display: flex;
        margin-top: 8px;
        .information {
          width: 5.4rem;
          height: 100%;
          background-color: #fff;
          margin-right: 8px;
          padding: 12px;
           box-sizing: border-box;
          .mytitle {
              font-size: 15px;
              color: #1a1a1a;
           }
           .information-item {
               display: flex;
               justify-content: space-between;
               flex-wrap: wrap;
               margin-top: 5px;
               .info-item {
                  width: 31%;
                  height: 46%;
                  border: 2px solid #d6dded;
                  margin-top: 8px;
                  border-radius: 2px;
                  .info-num {
                    width: 100%;
                    height: 60%;
                    font-size: 24px;
                    color: #5496cf;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  }
                  .info-txt {
                     width: 100%;
                     height: 40%;
                      display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #eaeef2;
                    color: #5d5d5d;
                    font-size: 14px;
                  }
               }
               .mymore {
                display: flex;
                align-items: center;
                justify-content: center;
                color: #636363;
               }
           }
        }
        .analysis {
          width: calc(100% - 5.5rem);
          height: 100%;
          background-color: #fff;
          .mytitle {
             display: flex;
             align-items: center;
             justify-content: space-between;
             margin: 12px 12px 0px 12px;
             color: #1a1a1a;
             span {
              font-size: 15px;
             }
             .em {
              display: flex;
              align-items: center;
              .num {
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #f0822a;
                margin: 0 10px;
              }
              .time {
                margin-left: 10px;
                font-size: 14px;
              }
             }
          }
        }

      }
      .itemize-region {
        width: 100%;
        height: 447px;
        display: flex;
        align-items: center;
        margin-top: 8px;
        .itemize {
           width: 5.4rem;
            height: 100%;
            background-color: #fff;
            margin-right: 8px;
             .mytitle {
              font-size: 15px;
              color: #1a1a1a;
              margin-top:12px;
              margin-left:12px;
           }
           .boxed {
              padding: 0px 20px;
              .tit {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  p {
                    font-size: 15px;
                    span {
                       margin-left: 10px;
                    }
                  }
              }
           }
           .progress {
            margin-bottom: 20px;
           }
           /deep/.el-progress-bar {
            padding-right: 0px;
           }
           /deep/.el-progress__text {
            display: none;
           }
        }
        .region {
             width: calc(100% - 5.5rem);
             height: 100%;
             background-color: #fff;
              .mytitle {
              font-size: 15px;
              color: #1a1a1a;
               margin-top:12px;
               margin-left:12px;
           }
             .mytable {
               margin: 0px 12px;
             }
        }

      }
   }
}
</style>